import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { ChecklistSmallIcon } from "@activecollab/components";
import PropTypes from "prop-types";
import { makeGetOpenSubtaskCountByIdSelector } from "~/store/selectors/selector.tasks.jsx";
import TaskObjectsCount from "./TaskObjectsCount.jsx";

export const SubtasksCount = ({ id }) => {
  const getOpenSubtaskCountById = useMemo(makeGetOpenSubtaskCountByIdSelector, []);
  const count = useSelector((state) => getOpenSubtaskCountById(state, id));
  return count > 0 ? (
    <TaskObjectsCount
      iconType={ChecklistSmallIcon}
      count={count}
    />
  ) : null;
};

SubtasksCount.propTypes = {
  id: PropTypes.oneOfType([
    PropTypes.string, // string is used as placeholder ID until backend returns the real ID
    PropTypes.number,
  ]),
};
